import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLocationPinIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.65625 6.48438C7.65625 7.10598 7.90318 7.70212 8.34272 8.14166C8.78226 8.58119 9.3784 8.82812 10 8.82812C10.6216 8.82812 11.2177 8.58119 11.6573 8.14166C12.0968 7.70212 12.3437 7.10598 12.3438 6.48438C12.3437 5.86277 12.0968 5.26663 11.6573 4.82709C11.2177 4.38756 10.6216 4.14062 10 4.14062C9.3784 4.14062 8.78226 4.38756 8.34272 4.82709C7.90318 5.26663 7.65625 5.86277 7.65625 6.48438Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 1.21094C11.3986 1.21094 12.7399 1.76653 13.7289 2.75549C14.7178 3.74445 15.2734 5.08577 15.2734 6.48438C15.2734 9.02422 11.2641 14.7086 10.2375 16.1227C10.2101 16.16 10.1744 16.1903 10.1331 16.2112C10.0919 16.2321 10.0463 16.243 10 16.243C9.95374 16.243 9.90814 16.2321 9.86688 16.2112C9.82561 16.1903 9.78986 16.16 9.7625 16.1227C8.73594 14.7086 4.72656 9.02422 4.72656 6.48438C4.72656 5.08577 5.28216 3.74445 6.27112 2.75549C7.26008 1.76653 8.6014 1.21094 10 1.21094Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6711 14.5195C16.8055 14.9422 18.2031 15.6477 18.2031 16.4461C18.2031 17.7406 14.5312 18.7898 10 18.7898C5.46875 18.7898 1.79688 17.7406 1.79688 16.4461C1.79688 15.6492 3.18828 14.9453 5.3125 14.5219",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgLocationPinIcon;
